import { render } from "./CopyTextModal.vue?vue&type=template&id=c4549572"
import script from "./CopyTextModal.vue?vue&type=script&lang=js"
export * from "./CopyTextModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__